import { render, staticRenderFns } from "./paging.vue?vue&type=template&id=571fc3f8&scoped=true&"
import script from "./paging.vue?vue&type=script&lang=js&"
export * from "./paging.vue?vue&type=script&lang=js&"
import style0 from "./paging.vue?vue&type=style&index=0&id=571fc3f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571fc3f8",
  null
  
)

export default component.exports